import { Heart, X, Edit, Edit2 } from "react-feather";
import React from "react";
import IconClose from "../../public/icons/x.svg";
import { PersonalNavigationEntry } from "../../helper/interfaces";
import { AppContext } from "../../provider/AppContextProvider";
import { AppTheme } from "../../helper/enums";
import { getLinkObjectFromTeaser } from "../../helper/link";
interface MyNewsProps {
  myNews: PersonalNavigationEntry[];
  editMode: boolean;
  removeFromMyNews: Function;
  selectEntry: Function;
}

const MyNews = ({
  myNews,
  editMode,
  removeFromMyNews,
  selectEntry,
}: MyNewsProps) => {
  return (
    <div className={`my-news ${editMode ? "my-news__edit" : ""}`}>
      {myNews.length > 0 ? (
        <React.Fragment>
          {myNews.map((n) => {
            let externalLink = "";
            const linkObject = getLinkObjectFromTeaser(n);
            const internalLink = linkObject.internalLink;

            if (!internalLink || internalLink == "") {
              externalLink = linkObject.externalLink ?? '';
            }

            return editMode ? (
              <div key={n.id} className="my-news-item">
                <div className="my-news-item-title">{n.title}</div>
                {editMode && (
                  <button
                    onClick={() => removeFromMyNews(n)}
                    className="my-news-item-button"
                  >
                    Entfernen
                  </button>
                )}
              </div>
            ) : (
              <a
                key={n.id}
                href={internalLink ?? externalLink ?? ''}
                onClick={() => selectEntry(n.id)}
                className="my-news-item"
              >
                {n.title}
              </a>
            );
          })}
          {myNews.length == 3 && editMode && (
            <div className="my-news-max-items">
              Sie können maximal drei Favoriten auswählen.
            </div>
          )}
        </React.Fragment>
      ) : (
        <p className="empty-text">Noch nichts ausgewählt</p>
      )}
    </div>
  );
};

interface MyFavsProps {
  editMode: boolean;
  setEditMode: Function;
  selectEntry: Function;
}

export default function MyFavs(props: MyFavsProps) {
  const { personalResorts, setPersonalResorts, bookmarkedTeaserIds } =
    React.useContext(AppContext);

  const removeFromMyNews = (item: PersonalNavigationEntry) => {
    setPersonalResorts(personalResorts.filter((e) => e !== item));
  };

  return (
    <div className="fav-wrapper">
      <Heart />
      <div className="fav-info__wrapper">
        <div className="fav-info__title">
          <p>Meine Favoriten</p>
          <button
            className="nav-header-icon-wrapper"
            onClick={() => props.setEditMode(!props.editMode)}
          >
            {process.env.NEXT_PUBLIC_APP_THEME == AppTheme.nn ? (
              !props.editMode ? (
                <Edit aria-label="Favoriten bearbeiten" />
              ) : (
                <X aria-label="Favoriten speichern" />
              )
            ) : !props.editMode ? (
              <Edit2 aria-label="Favoriten bearbeiten" />
            ) : (
              <IconClose className="nav-header-icon stroke-current" aria-label="Favoriten speichern" />
            )}
          </button>
        </div>
        <MyNews
          myNews={personalResorts}
          editMode={props.editMode}
          removeFromMyNews={removeFromMyNews}
          selectEntry={props.selectEntry}
        />
        {bookmarkedTeaserIds && bookmarkedTeaserIds.length > 0 && (
          <div className="watchlist">
            <div className="nav-item">
              <div className="nav-item-text-wrapper">
                <a href={`/merkliste`} className="nav-item-text">
                  Meine Merkliste
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
